export default "__VITE_ASSET__D0g6p3Gr__"